import { render, staticRenderFns } from "./addUserModal.vue?vue&type=template&id=1b22a2c6&scoped=true&"
import script from "./addUserModal.vue?vue&type=script&lang=js&"
export * from "./addUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22a2c6",
  null
  
)

export default component.exports